import apiCall from "../api/Api";

const UserProfileService = {
  getUserProfile: async () => {
    return await apiCall("GET", "get-user-profile");
  },
};

export default UserProfileService;
